import { render, staticRenderFns } from "./DeviceRealTimeInfo.vue?vue&type=template&id=f1818cd2&scoped=true"
import script from "./DeviceRealTimeInfo.vue?vue&type=script&lang=js"
export * from "./DeviceRealTimeInfo.vue?vue&type=script&lang=js"
import style0 from "./DeviceRealTimeInfo.vue?vue&type=style&index=0&id=f1818cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1818cd2",
  null
  
)

export default component.exports